import { render, staticRenderFns } from "./MmplPartList.vue?vue&type=template&id=015bb89c&"
import script from "./MmplPartList.vue?vue&type=script&lang=js&"
export * from "./MmplPartList.vue?vue&type=script&lang=js&"
import style0 from "./MmplPartList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports